export class UserMenuResponseModel {
        public name = "";
        public url = "";
}